import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '@/constants/token.constant';
import token from '@/lib/token';
import axios, { AxiosResponse, AxiosRequestConfig, AxiosError } from 'axios';

const host = `${process.env.SERVER_URL}`;
const apiClient = axios.create({
  baseURL: host,
});

const logOnDev = (message: string, log?: AxiosResponse | AxiosRequestConfig | AxiosError) => {
  if (process.env.NODE_ENV === 'development') {
    console.info(message, log);
  }
};

// DISABLED AUTH REFRESH LOGIC
//const refreshAuthLogic = (failedRequest: any) => apiClient.post('/auth/refresh-token').then((tokenRefreshResponse) => {
//  if (failedRequest.)
//  token.setToken(ACCESS_TOKEN_KEY, tokenRefreshResponse.data.token);
//  failedRequest.response.config.headers['Authorization'] = `Token ${tokenRefreshResponse.data.token}`;
//});
//
//createAuthRefreshInterceptor(apiClient, refreshAuthLogic);

apiClient.interceptors.request.use((request: AxiosRequestConfig) => {
  const jwtToken: string | null = token.getToken(ACCESS_TOKEN_KEY);
  const { method, url } = request;

  if (jwtToken) {
    if (!request.headers) {
      request.headers = {};
    }
    request.headers['Authorization'] = `Token ${jwtToken}`;
  }

  logOnDev(`🚀 [${method?.toUpperCase()}] ${url} | Request`, request);

  return request;
});

export const setInterceptor = (tokenCb: (token: String) => {}) => {
  return apiClient.interceptors.response.use(
    (response) => {
      const { method, url } = response.config;
      const { status } = response;
      /*if (headers['authorization']) {
        if (headers['authorization'].startsWith('Token')) {
          // eventually we got a new token
          const jwtToken = headers['authorization'].split(' ')[1];
          token.setToken(ACCESS_TOKEN_KEY, jwtToken);
        }
      }*/


      logOnDev(`✨ [${method?.toUpperCase()}] ${url} | Response ${status}`, response);

      return response;
    },
    async (error) => {
      const originalRequest = error.config;
      const { message } = error;
      const { status, data } = error.response;
      const { method, url } = error.config;

      if (status === 0) {
        // Network Error Handling!!!
        console.warn("network error, so redirect to login page...");
        token.removeToken(ACCESS_TOKEN_KEY);
        token.removeToken(REFRESH_TOKEN_KEY);
        window.location.href = '/login';
        return
      }

      if (status === 401 && !originalRequest._retry) {
        // Unauthorized Error Handling!!!

        originalRequest._retry = true;

        try {
          console.warn("try to refresh token...");
          const refreshToken = token.getToken(REFRESH_TOKEN_KEY);
          const response = await axios.create({
            baseURL: host,
          }).post('/auth/refresh', { refreshToken });
          console.warn("response to refresh token...")
          const { token: newToken, refreshToken: newRefreshToken } = response.data;

          tokenCb(newToken);
          token.setToken(ACCESS_TOKEN_KEY, newToken);
          token.setToken(REFRESH_TOKEN_KEY, newRefreshToken );

          originalRequest.headers['Authorization'] = `Token ${newToken}`;
          return axios(originalRequest)
        } catch (error) {
          // Refresh Token Error Handling!!!
          console.warn("refresh token doesnt work, so redirect to login page...");
          token.removeToken(ACCESS_TOKEN_KEY);
          token.removeToken(REFRESH_TOKEN_KEY);
          window.location.href = '/login';

        }
      }
      // 404 Error Handling!!!
      // any Error Handling!!!

      logOnDev(`🚨 [${method?.toUpperCase()}] ${url} | Error ${status} ${data?.message || ''} | ${message}`, error);

      return Promise.reject(error);
    },
  );
}

export default apiClient;
